import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { proxyUrl } from '@sorare/core/src/atoms/ui/ResponsiveImg';

import defaultBanner from './assets/banner_none.webp';

type Props = {
  bannerUrl?: string | null;
  className?: string;
};

const Root = styled.div<{ rounded?: boolean }>`
  position: relative;
  isolation: isolate;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const Banner = ({ bannerUrl, ...rest }: PropsWithChildren<Props>) => (
  <Root
    style={{
      backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, #0a0c14 63%), url(${
        bannerUrl
          ? proxyUrl(bannerUrl, {
              cropWidth: 1280,
              xl: true,
              dpis: 1,
            })
          : defaultBanner
      })`,
    }}
    {...rest}
  />
);
